import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Login from './components/Login';
import Signup from './components/Signup';
import Dashboard from './components/Dashboard';
import PrivacyPolicy from './components/PrivacyPolicy';

const WELCOME_MESSAGES = [
  (name) => `Welcome back, ${name}!`,
  (name) => `Good to see you, ${name}.`,
  (name) => `Hey ${name}, ready to dig in?`,
  (name) => `Hello, ${name}!`,
  (name) => `Great to have you back, ${name}.`,
  (name) => `Hi ${name}, let's get to work.`,
];

function withWelcome(userData) {
  if (!userData) return userData;
  const firstName = userData.name?.split(' ')[0] || userData.name;
  const msg = WELCOME_MESSAGES[Math.floor(Math.random() * WELCOME_MESSAGES.length)](firstName);
  return { ...userData, _welcomeMsg: msg };
}

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showSignup, setShowSignup] = useState(false);
  const [org, setOrg] = useState(null);

  // Check if user is already logged in on app load
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/check`, {
          withCredentials: true
        });

        if (response.data.loggedIn && response.data.user) {
          setUser(withWelcome(response.data.user));
        }
      } catch (err) {
        console.error('Auth check failed:', err);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  const fetchOrg = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/org`, {
        withCredentials: true
      });
      if (response.data.success) {
        setOrg(response.data.org);
      }
    } catch (err) {
      console.error('Failed to fetch org:', err);
    }
  };

  const handleLoginSuccess = async (userData) => {
    setUser(withWelcome(userData));
    await fetchOrg();
  };

  const handleSignupSuccess = async (userData) => {
    setUser(withWelcome(userData));
    setShowSignup(false);
    await fetchOrg();
  };

  const handleLogout = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/logout`, {}, {
        withCredentials: true
      });
    } catch (err) {
      console.error('Logout error:', err);
    }
    setUser(null);
  };

  // Show privacy policy page without auth
  if (window.location.pathname === '/privacy') {
    return <PrivacyPolicy />;
  }

  // Show loading state while checking auth
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Loading...
      </div>
    );
  }

  if (!user) {
    if (showSignup) {
      return (
        <Signup
          onSignupSuccess={handleSignupSuccess}
          onBackToLogin={() => setShowSignup(false)}
        />
      );
    }
    return (
      <Login
        onLoginSuccess={handleLoginSuccess}
        onShowSignup={() => setShowSignup(true)}
      />
    );
  }

  return <Dashboard user={user} org={org} onLogout={handleLogout} />;
}

export default App;